export default __webpack_public_path__ + "static/media/Serpent Sword Technique.5642d9f1.png";